
import rp500 from "./rp500";
import rp501 from "./rp501";
import rp502 from "./rp502";
import rp503 from "./rp503";
import rp504 from "./rp504";
import rp505 from "./rp505";
import rp507 from "./rp507";
import rp508 from "./rp508";
import rp509 from "./rp509";
import rp511 from "./rp511";
import rp510 from "./rp510";
import rp516 from "./rp516";
import rp515 from "./rp515";

export default {
    rp500,rp501,rp502,rp503,rp504,rp505,rp507,rp508,rp509,rp511,rp510,rp516,rp515
}